export default __webpack_public_path__ + "static/download-mockup-ad81f6c5a610434b66de1aaebd4ef957.svg";